import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, OnDestroy } from '@angular/core';


@Component({
    selector: 'btn-cell-renderer-delete-clipboard',
    template: `
		<em>
			<div class="info-btn">
				<i *ngIf="enableDetails" title="Details" class="fas fa-info custom-icon custom-icon-i"  (click)="btnClickedHandler('details')"></i>
				<i *ngIf="enableDelete" title="Delete" class="fas fa-trash-alt custom-icon" (click)="btnClickedHandler('delete')"></i>
			</div>
		</em>`,
	styles: [`
        .info-btn{
            display: flex;
            gap: 0.8rem;
            color: #fff;
            cursor: pointer;
        }

		::ng-deep .custom-icon {
			/* background: linear-gradient(#000, rgb(49, 49, 49)); */
			border: 1px solid #676A6E;
			padding: 4px 4px 4px 4px;
			/* color: #fff; */
			cursor: pointer;
			background: transparent linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat padding-box;
			opacity: 1;
			font: normal normal bold 10px;
			color: #676a6e;
		}

		::ng-deep .custom-icon-i {
			display: inline-flex;
    	justify-content: center;
    	width: 20px;
		}
    `],
    standalone: false
})
export class BtnCellRendererDetailsDelete implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableDetails: boolean = false;
	enableDelete: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//summary
		if (this.params.colDef.field == "summary_detailsdelete") {  // NOSONAR
			this.enableDetails = true;
			this.enableDelete = true;
		}
		//summary-details
		if (this.params.colDef.field == "summary_details" && this.params.data.poLine != null) {  // NOSONAR
			this.enableDetails = true;
		}

	}

	btnClickedHandler(action) {

		if (action == 'delete') {  // NOSONAR
			this.params.context.componentParent.deleteTemplateRow(this.params.data, this.pageName);
		}
		else if (action == 'details') {  // NOSONAR
			this.params.context.componentParent.detailsTemplateRow(this.params.data, this.pageName);
		}
	}

	ngOnDestroy() {
		// do nothing 
	}
}
